import { DisplayTitle } from '@vkontakte/vkui';

interface CustomTextProps {
  Component?: 'h2' | 'h3' | 'p';
  weight: '1' | '2';
  children: React.ReactNode;
}

export function CustomText(props: CustomTextProps) {
  const { Component, weight, children } = props;

  return (
    <DisplayTitle level="4" weight={weight} Component={Component}>
      {children}
    </DisplayTitle>
  );
}
